import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNewbuildingHouseByOfferId } from '../../../../../../selectors/newbuilding';
import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const FinishingFieldContainer: React.VFC = () => {
  const { id, published } = useOfferContext();
  const house = useSelector(selectNewbuildingHouseByOfferId(id));
  const finishingDate = house && house.finishing;

  if (!finishingDate) {
    return <EmptyField published={published} />;
  }

  return <TextField published={published}>{finishingDate}</TextField>;
};
